<template>
  <div class="group-dialog">
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               width="700px"
               top="10vh"
               :show-close="false"
               :title="title">
      <el-form label-width="110px"
               label-position="left"
               :model="form"
               ref="groupTemplateForm"
               size="medium"
               :rules="rules">
        <el-form-item :label="$t('groupDialog.TemplateName')"
                      prop="Name">
          <el-input v-model='form.Name'
                    size="small"
                    :placeholder="$t('groupDialog.TemplateName')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog()"
                   size="small">{{$t('groupDialog.Cancel')}}</el-button>
        <el-button type="primary"
                   size="small"
                   :loading="btnLoading"
                   @click="saveAs()">{{$t('groupDialog.Save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveAsTaskTemplateByTaskGroup } from '@/api/config'
import { mapState } from 'vuex'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      btnLoading: false,
      title: this.$t('groupDialog.SaveAsTaskTemplate'),
      form: {
        Name: null,
        GroupId: null
      },
      rules: {
        Name: [
          { required: true, message: this.$t('groupDialog.PleaseEnterATemplateName'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['jobsiteID'])
  },
  created () {
    // this.getTaskById()
  },
  mounted () {

  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.form.Name = this.name + ' Template'
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs['groupTemplateForm'].resetFields()
      this.form = {
        Name: null
      }
      this.$emit('closeDialog')
    },
    saveAs () {
      this.$refs['groupTemplateForm'].validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          this.form.GroupId = this.id
          saveAsTaskTemplateByTaskGroup(this.form).then(res => {
            this.btnLoading = false
            this.closeDialog()
          }).catch(
            this.btnLoading = false
          )
        } else {
        }
      })
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
</style>
